<template>
  <div class="pizza-wheel-page pk-account-panel">
    <section class="pizza-wheel-hero">
      <div>
        <span>披萨转盘</span>
        <h1>&#25259;&#33832;&#36716;&#30424;</h1>
        <p>&#36873;&#25321;&#21306;&#22495;&#24182;&#21551;&#21160;&#36716;&#30424;&#65292;&#39029;&#38754;&#20808;&#36824;&#21407;&#30446;&#26631;&#31449;&#30340;&#21069;&#31471;&#20132;&#20114;&#32467;&#26500;&#12290;</p>
      </div>
      <button @click="showRules = true">&#26597;&#30475;&#35268;&#21017;</button>
    </section>

    <section class="pizza-wheel-layout">
      <main class="pizza-wheel-stage">
        <div class="pizza-wheel-disc">
          <div class="pizza-wheel-pointer"></div>
          <div class="pizza-wheel-slices" :class="{ spinning: isSpinning }">
            <span v-for="slice in wheelSlices" :key="slice.label" :style="{ '--tone': slice.color }">
              {{ slice.label }}
            </span>
          </div>
          <button class="pizza-wheel-spin" :disabled="isSpinning" @click="spinPreview">{{ isSpinning ? "转动中" : "开始" }}</button>
        </div>

        <div class="pizza-wheel-bets">
          <button v-for="bet in bets" :key="bet" :class="{ active: bet === activeBet }" @click="activeBet = bet">
            {{ bet }}
          </button>
        </div>
      </main>

      <aside class="pizza-wheel-side">
        <div class="pizza-wheel-panel-head">
          <strong>&#22870;&#27744;</strong>
          <span>奖池</span>
        </div>
        <div v-if="prizes.length" class="pizza-wheel-prizes">
          <article v-for="item in prizes" :key="item.name">
            <img :src="item.img" :alt="item.name" />
            <div>
              <strong>{{ item.name }}</strong>
              <span>{{ item.price }}</span>
            </div>
          </article>
        </div>
        <p v-else class="pizza-wheel-empty">暂无可参与的转盘奖池</p>
      </aside>
    </section>

    <section class="pizza-wheel-history">
      <div class="pizza-wheel-panel-head">
        <strong>&#26368;&#36817;&#32467;&#26524;</strong>
        <span>历史记录</span>
      </div>
      <div v-if="history.length" class="pizza-wheel-history-row">
        <article v-for="item in history" :key="item.id">
          <img :src="item.img" :alt="item.name" />
          <strong>{{ item.name }}</strong>
          <span>{{ item.price }}</span>
        </article>
      </div>
      <p v-else class="pizza-wheel-empty">暂无已结算转盘记录</p>
    </section>

    <section class="pizza-wheel-gift-table">
      <header><span>奖励类型</span><strong>披萨转盘</strong></header>
      <div v-if="giftTypes.length" class="pizza-wheel-gift-grid">
        <article v-for="gift in giftTypes" :key="gift.title">
          <b :style="{ '--gift': gift.color }">{{ gift.symbol }}</b>
          <div><strong>{{ gift.title }}</strong><span>{{ gift.note }}</span></div>
        </article>
      </div>
      <p v-else class="pizza-wheel-empty">奖励类别与参与条件将在活动开放后展示</p>
    </section>

    <section class="pizza-wheel-rules">
      <article>
        <b>1</b>
        <strong>&#36873;&#25321;&#37329;&#39069;</strong>
        <span>&#36873;&#25321;&#20320;&#35201;&#21442;&#19982;&#30340;&#25259;&#33832;&#24065;&#37329;&#39069;&#12290;</span>
      </article>
      <article>
        <b>2</b>
        <strong>&#21551;&#21160;&#36716;&#30424;</strong>
        <span>&#36716;&#30424;&#21160;&#30011;&#19982;&#23545;&#24212;&#32467;&#26524;&#35268;&#21017;&#38656;&#30001;&#21518;&#21488;&#37197;&#32622;&#21518;&#21551;&#29992;&#12290;</span>
      </article>
      <article>
        <b>3</b>
        <strong>&#33719;&#24471;&#22870;&#21169;</strong>
        <span>&#26410;&#30830;&#35748;&#22870;&#27744;&#12289;&#36164;&#26684;&#19982;&#32467;&#31639;&#35268;&#21017;&#21069;&#65292;&#19981;&#20250;&#21457;&#25918;&#22870;&#21169;&#25110;&#20889;&#20837;&#32972;&#21253;&#12290;</span>
      </article>
    </section>

    <div v-if="showRules" class="pizza-wheel-modal" @click.self="showRules = false">
      <section>
        <button class="pizza-wheel-modal-close" @click="showRules = false">×</button>
        <span>披萨转盘</span>
        <h2>玩法说明</h2>
        <p>每日登录可获得一次转盘机会；完成指定任务并领取对应奖励后，可获得第二次机会。</p>
        <p>抽到的奖励需完成对应要求后才能领取，未领取奖励的有效期以活动说明为准。</p>
        <em>当前为动画和页面流程预览，不会扣除余额或发放奖励。</em>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "dome",
  data() {
    return {
      activeBet: "10",
      isSpinning: false,
      showRules: false,
      spinTimer: null,
      bets: ["1", "5", "10", "25", "50", "100"],
      wheelSlices: [
        { label: "BONUS", color: "#ef5737" },
        { label: "TOP UP", color: "#f1b84b" },
        { label: "GIFT", color: "#74ce49" },
        { label: "CASE", color: "#5f85e8" },
        { label: "SKIN", color: "#a969de" },
      ],
      giftTypes: [],
      prizes: [],
      history: [],
    };
  },
  beforeDestroy() {
    window.clearTimeout(this.spinTimer);
  },
  methods: {
    spinPreview() {
      if (this.isSpinning) return;
      this.isSpinning = true;
      this.spinTimer = window.setTimeout(() => {
        this.isSpinning = false;
        this.$message.info("动画预览完成。");
      }, 2600);
    },
  },
};
</script>

<style lang="less" scoped>
.pizza-wheel-page {
  min-height: calc(100vh - 199px);
  padding: 18px 24px 96px;
  color: #f4f6ff;
  background:
    radial-gradient(ellipse at 50% 260px, rgba(255, 208, 102, 0.08), transparent 500px),
    #191b26;
}

.pizza-wheel-hero {
  min-height: 104px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #2b2d3c;
  border-radius: 8px;
  background:
    radial-gradient(ellipse at 18% 50%, rgba(255, 208, 102, 0.12), transparent 340px),
    #20222f;
}

.pizza-wheel-hero span,
.pizza-wheel-panel-head span {
  color: #ffbd42;
  font-size: 12px;
  font-weight: 900;
}

.pizza-wheel-hero h1 {
  margin: 4px 0 6px;
  color: #fff7df;
  font-size: 26px;
}

.pizza-wheel-hero p {
  margin: 0;
  color: #8f98ab;
  font-size: 13px;
}

.pizza-wheel-hero button {
  height: 42px;
  padding: 0 22px;
  color: #ecd8b8;
  border: 1px solid rgba(236, 216, 184, 0.42);
  border-radius: 7px;
  background: transparent;
  font-weight: 900;
}

.pizza-wheel-layout {
  margin-top: 8px;
  display: grid;
  grid-template-columns: minmax(620px, 1fr) 360px;
  gap: 8px;
}

.pizza-wheel-stage,
.pizza-wheel-side,
.pizza-wheel-history,
.pizza-wheel-rules article {
  border: 1px solid #2b2d3c;
  border-radius: 8px;
  background: #20222f;
}

.pizza-wheel-stage {
  min-height: 590px;
  display: grid;
  place-items: center;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 43%, rgba(253, 129, 41, 0.38), transparent 32%),
    radial-gradient(ellipse at 6% 50%, rgba(236, 69, 31, 0.28), transparent 32%),
    radial-gradient(ellipse at 94% 50%, rgba(105, 48, 195, 0.31), transparent 32%),
    #1f2030;
}

.pizza-wheel-stage::before,
.pizza-wheel-stage::after {
  content: "";
  width: 190px;
  height: 290px;
  position: absolute;
  top: 50%;
  opacity: 0.66;
  filter: blur(2px);
  pointer-events: none;
}

.pizza-wheel-stage::before { left: -48px; background: radial-gradient(ellipse at left, #ff5a1f, transparent 68%); transform: translateY(-50%) skewY(-18deg); }
.pizza-wheel-stage::after { right: -48px; background: radial-gradient(ellipse at right, #8450dc, transparent 68%); transform: translateY(-50%) skewY(18deg); }

.pizza-wheel-disc {
  width: 430px;
  height: 430px;
  position: relative;
  border: 10px solid #252837;
  border-radius: 50%;
  background:
    conic-gradient(#ef5737 0 72deg, #f1b84b 72deg 144deg, #74ce49 144deg 216deg, #5f85e8 216deg 288deg, #a969de 288deg 360deg);
  box-shadow:
    0 0 70px rgba(255, 208, 102, 0.14),
    inset 0 0 0 12px rgba(25, 27, 38, 0.82);
}

.pizza-wheel-pointer {
  width: 0;
  height: 0;
  position: absolute;
  left: 50%;
  top: -30px;
  z-index: 3;
  transform: translateX(-50%);
  border-left: 17px solid transparent;
  border-right: 17px solid transparent;
  border-top: 0;
  border-bottom: 34px solid #fff7df;
  filter: drop-shadow(0 0 14px rgba(255, 208, 102, 0.7));
}

.pizza-wheel-slices {
  position: absolute;
  inset: 0;
  animation: pizzaWheelFloat 7s ease-in-out infinite;
}

.pizza-wheel-slices.spinning {
  animation: pizzaWheelSpin 2.6s cubic-bezier(.16, .78, .16, 1) both;
}

.pizza-wheel-slices span {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 70px;
  height: 30px;
  margin: -15px 0 0 -35px;
  color: #11131d;
  text-align: center;
  font-weight: 1000;
  transform-origin: 35px 15px;
}

.pizza-wheel-slices span:nth-child(1) { transform: rotate(36deg) translateY(-158px) rotate(-36deg); }
.pizza-wheel-slices span:nth-child(2) { transform: rotate(108deg) translateY(-158px) rotate(-108deg); }
.pizza-wheel-slices span:nth-child(3) { transform: rotate(180deg) translateY(-158px) rotate(-180deg); }
.pizza-wheel-slices span:nth-child(4) { transform: rotate(252deg) translateY(-158px) rotate(-252deg); }
.pizza-wheel-slices span:nth-child(5) { transform: rotate(324deg) translateY(-158px) rotate(-324deg); }

.pizza-wheel-spin {
  width: 132px;
  height: 132px;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 4;
  transform: translate(-50%, -50%);
  color: #11131d;
  border: 8px solid #20222f;
  border-radius: 50%;
  background: linear-gradient(180deg, #ffd066, #ff8a1f);
  font-size: 22px;
  font-weight: 1000;
}

.pizza-wheel-spin:disabled {
  cursor: wait;
  filter: saturate(.7) brightness(.9);
}

.pizza-wheel-bets {
  position: absolute;
  left: 50%;
  bottom: 34px;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
}

.pizza-wheel-bets button {
  width: 66px;
  height: 42px;
  color: #aeb7ca;
  border: 1px solid #303443;
  border-radius: 6px;
  background: #252837;
  font-weight: 900;
}

.pizza-wheel-bets button.active {
  color: #fff7df;
  border-color: rgba(255, 208, 102, 0.5);
}

.pizza-wheel-panel-head {
  height: 58px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #2b2d3c;
}

.pizza-wheel-panel-head strong {
  color: #f4ead8;
  font-size: 16px;
}

.pizza-wheel-prizes {
  padding: 12px;
  display: grid;
  gap: 8px;
}

.pizza-wheel-empty {
  min-height: 122px;
  margin: 0;
  padding: 24px;
  display: grid;
  place-items: center;
  color: #929ab0;
  text-align: center;
}

.pizza-wheel-prizes article {
  min-height: 94px;
  padding: 10px;
  display: grid;
  grid-template-columns: 96px 1fr;
  gap: 10px;
  align-items: center;
  border: 1px solid #303443;
  border-radius: 7px;
  background: #252837;
}

.pizza-wheel-prizes img {
  max-width: 92px;
  max-height: 70px;
  object-fit: contain;
}

.pizza-wheel-prizes strong,
.pizza-wheel-history strong {
  color: #f5f7ff;
  font-size: 13px;
}

.pizza-wheel-prizes span,
.pizza-wheel-history span {
  display: block;
  margin-top: 6px;
  color: #ffbd42;
  font-weight: 900;
}

.pizza-wheel-history {
  margin-top: 8px;
  overflow: hidden;
}

.pizza-wheel-gift-table {
  margin-top: 14px;
  overflow: hidden;
  border: 1px solid #34384e;
  border-radius: 8px;
  background: #242637;
}

.pizza-wheel-gift-table > header {
  min-height: 68px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #34384e;
}

.pizza-wheel-gift-table > header span { color: #f0f2fb; font-size: 20px; font-weight: 1000; }
.pizza-wheel-gift-table > header strong { color: #ee713d; font-size: 12px; letter-spacing: .12em; }

.pizza-wheel-gift-grid { display: grid; grid-template-columns: repeat(5, 1fr); }
.pizza-wheel-gift-grid article { min-height: 132px; padding: 20px; display: grid; grid-template-columns: 42px minmax(0, 1fr); align-items: center; gap: 12px; border-right: 1px solid #34384e; }
.pizza-wheel-gift-grid article:last-child { border-right: 0; }
.pizza-wheel-gift-grid b { width: 40px; height: 40px; display: grid; place-items: center; color: #fff; border-radius: 50%; background: var(--gift); box-shadow: 0 0 22px var(--gift); font-size: 20px; }
.pizza-wheel-gift-grid strong, .pizza-wheel-gift-grid span { display: block; }
.pizza-wheel-gift-grid strong { color: #eef0fa; font-size: 14px; }
.pizza-wheel-gift-grid span { margin-top: 6px; color: #99a2b9; font-size: 12px; line-height: 1.45; }

.pizza-wheel-history-row {
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 8px;
}

.pizza-wheel-history article {
  min-height: 168px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #303443;
  border-radius: 7px;
  background:
    radial-gradient(circle at 50% 38%, rgba(255, 208, 102, 0.1), transparent 48%),
    #252837;
}

.pizza-wheel-history img {
  max-width: 138px;
  max-height: 88px;
  object-fit: contain;
}

.pizza-wheel-rules {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.pizza-wheel-rules article {
  min-height: 92px;
  padding: 18px;
  display: grid;
  grid-template-columns: 36px 1fr;
  column-gap: 12px;
}

.pizza-wheel-rules b {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  color: #11131d;
  border-radius: 50%;
  background: #ffbd42;
}

.pizza-wheel-rules strong {
  color: #fff7df;
}

.pizza-wheel-rules span {
  grid-column: 2;
  color: #8f98ab;
  font-size: 13px;
}

@keyframes pizzaWheelFloat {
  0%, 100% { transform: rotate(-2deg); }
  50% { transform: rotate(2deg); }
}

@keyframes pizzaWheelSpin {
  from { transform: rotate(0); }
  to { transform: rotate(1440deg); }
}

.pizza-wheel-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(9, 10, 16, .74);
}

.pizza-wheel-modal section {
  width: calc(100% - 48px);
  max-width: 510px;
  padding: 30px;
  position: relative;
  color: #b8c0d0;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 181, 48, .18), transparent 46%),
    #20222f;
  border: 1px solid rgba(255, 196, 82, .36);
  border-radius: 10px;
  box-shadow: 0 28px 70px rgba(0, 0, 0, .48);
}

.pizza-wheel-modal span { color: #ffbd42; font-size: 12px; font-weight: 900; letter-spacing: .12em; }
.pizza-wheel-modal h2 { margin: 8px 0 18px; color: #fff7df; font-size: 25px; }
.pizza-wheel-modal p { margin-top: 12px; line-height: 1.8; }
.pizza-wheel-modal em { display: block; margin-top: 18px; color: #ffcc78; font-size: 12px; font-style: normal; line-height: 1.7; }
.pizza-wheel-modal-close { width: 32px; height: 32px; position: absolute; right: 12px; top: 12px; color: #c4cad7; border: 1px solid #3a3e50; border-radius: 6px; background: #252837; font-size: 20px; cursor: pointer; }

@media (max-width: 1280px) {
  .pizza-wheel-layout,
  .pizza-wheel-rules {
    grid-template-columns: 1fr;
  }
}
</style>
